/**
 * sl-4wjh.2.1: Image Generation feature tab.
 * Thin wrapper around CapabilityFeatureTab for capability='image'.
 */
import type { AnalyticsPeriodRange, ContextType } from '../types';
import { CapabilityFeatureTab } from './capability-feature-tab';

export interface ImageGenTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  context: ContextType;
}

export const ImageGenTab = (props: ImageGenTabProps) => (
  <CapabilityFeatureTab
    {...props}
    capability="image"
    cacheKey="image-gen"
    countCardKey="images-generated"
    countCardDefault="Images generated"
  />
);
